import {Popup} from 'semantic-ui-react';
import React from 'react';
import PropTypes from 'prop-types';

import {EventContentVariantPopup} from '@utils/eventContentVariant/EventContentVariantPopup';

export const ReportScopesPopup = ({scopes, reportField, includesAllStreams}) => {
    const scope = includesAllStreams
        ? 'All streams'
        : scopes.map((scope, i) => (
            <div key={i}>
                {scope.text} <EventContentVariantPopup eventContentVariant={scope.event_content_variant} />
            </div>
        ));

    return <Popup
        trigger={<span>{reportField}</span>}
        content={scope}
        size='small'
        hoverable
    />;
};

ReportScopesPopup.propTypes = {
    scopes: PropTypes.array,
    reportField: PropTypes.string,
    includesAllStreams: PropTypes.bool,
};

ReportScopesPopup.defaultProps = {
    scopes: [],
    reportField: '',
    includesAllStreams: false,
};
